import moment from "moment";

import { IActivity, ActivityEntity, ISubscriber } from "./types";

/**
 * Activity entity schema convert to model
 */
export function mapActivityFromEntity(entity: ActivityEntity): IActivity {
  return {
    id: entity.id,
    key: entity.key,
    integrationId: entity.integrationId,
    activityTypeId: entity.activityTypeId,
    otherActivityTypeIds: entity.otherActivityTypeIds || [],
    oldKeys: entity.oldKeys || [],
    activityGroupId: entity.activityGroupId,
    activityCommunityId: entity.activityCommunityId,
    title: entity.title,
    adminTitle: entity.adminTitle || entity.title,
    heroTitle: entity.heroTitle,
    subTitle: entity.subTitle,
    secondSubTitle: entity.secondSubTitle,
    establishmentTitle: entity.establishmentTitle,
    ticketLink: entity.ticketLink,
    placeDescription: entity.placeDescription,
    dateOrder: entity.dateOrder,
    durationString: entity.durationString,
    description: entity.description,
    shortDescription: entity.shortDescription,
    artistTitle: entity.artistTitle,
    timeDescription: entity.timeDescription,
    calendarString: entity.calendarString,
    isWebPublish: entity.isWebPublish,
    listNote: entity.listNote,
    rules: entity.rules || [],
    isFree: entity.isFree || false,
    isFreePrivate: entity.isFreePrivate || false,
    profileImageVertical: entity.profileImageVertical,
    profileImageHorizontal: entity.profileImageHorizontal,
    profileImageHero: entity.profileImageHero,
    searchString: entity.searchString,
    placeImage: entity.placeImage,
    artistString: entity.artistInfo,
    activityRuleString: entity.activityRules,
    variantDate: entity.variantDate
      ? moment(entity.variantDate).format("DD-MM-YYYY HH:mm")
      : "-",
    dateString: entity.dateString,
    order: entity.order || 0,
    highlighted: entity.isHighlighted || false,
    gallery: entity.gallery || [],
    schema: entity.schema,
    defaultVideo: entity.defaultVideo,
    language: entity.language,
    relationId: entity.languageRelationId,
    createdBy: entity.createdBy,
    updatedBy: entity.modifiedBy,
    createdAt: entity.createdOn || entity.CreatedOn,
    updatedAt: entity.modifiedOn || entity.ModifiedOn,
    heroSlider: entity.heroSlider || [],
    isActive: entity.isActive === true,
    isFeaturedActivity: entity.isFeaturedActivity,
  };
}

/**
 * Activity model schema convert to entity
 */
export function mapActivityFromModel(model: IActivity): ActivityEntity {
  return {
    id: model.id,
    key: model.key,
    integrationId: model.integrationId,
    activityTypeId: model.activityTypeId,
    otherActivityTypeIds: model.otherActivityTypeIds || [],
    oldKeys: model.oldKeys || [],
    activityGroupId: model.activityGroupId,
    activityCommunityId: model.activityCommunityId,
    artistTitle: model.artistTitle,
    title: model.title,
    subTitle: model.subTitle,
    secondSubTitle: model.secondSubTitle,
    establishmentTitle: model.establishmentTitle,
    heroTitle: model.heroTitle,
    placeDescription: model.placeDescription,
    durationString: model.durationString,
    adminTitle: model.adminTitle,
    ticketLink: model.ticketLink,
    description: model.description,
    calendarString: model.calendarString,
    dateString: model.dateString,
    searchString: model.searchString,
    dateOrder: model.dateOrder || 0,
    rules: model.rules || [],
    listNote: model.listNote,
    isFree: model.isFree || false,
    isFreePrivate: model.isFreePrivate || false,
    shortDescription: model.shortDescription,
    timeDescription: model.timeDescription,
    profileImageVertical: model.profileImageVertical,
    profileImageHorizontal: model.profileImageHorizontal,
    profileImageHero: model.profileImageHero,
    placeImage: model.placeImage,
    artistInfo: model.artistString,
    activityRules: model.activityRuleString,
    isHighlighted: model.highlighted || false,
    schema: model.schema,
    order: model.order || 0,
    gallery: model.gallery || [],
    defaultVideo: model.defaultVideo,
    language: model.language,
    languageRelationId: model.relationId || undefined,
    heroSlider: model.heroSlider || [],
    isActive: model.isActive === true,
  };
}

export function mapGetSubscriberEmailsExcel(entity: ISubscriber) {
  return {
    "Etkinlik Adı": entity.activityTitle,
    Email: entity.email,
  };
}
